export default {
    intro: '빈칸을 채워 표를 완성해 보세요!',

};
